import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">爆料投稿 / 商务合作</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">有猛料？想合作？我们随时恭候</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {contactData.description}
          </p>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-[11px] text-foreground-400">投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-800 truncate">{contactData.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 flex-shrink-0">
                <i className="ri-wechat-line text-lg text-accent-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-[11px] text-foreground-400">微信</p>
                <p className="text-sm font-medium text-foreground-800 truncate">{contactData.wechat}</p>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-secondary-100/70 rounded-lg">
            <div className="flex items-start gap-2.5">
              <i className="ri-information-line text-sm text-secondary-600 mt-0.5 flex-shrink-0"></i>
              <p className="text-xs md:text-sm text-secondary-700 leading-relaxed">{contactData.tips}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}